import {
    Avatar,
    Box,
    Button,
    Typography,
} from "@mui/material";
import { identifiersData } from "data";
import { PropTypes } from "prop-types";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { theme } from "theme";

const Blank = ({
    buttonName,
    buttonText,
    description,
    onClickButton,
    title,
    withoutButton,
}) => {
    const [showLogo, setShowLogo] = useState(true);

    const { t } = useTranslation();

    return (
        <Box>
            {showLogo && window?.__RUNTIME_CONFIG__?.SHOW_CMS_LOGO === "true" ? ( // eslint-disable-line
                <Avatar
                    alt={t("imageAlternatives.logo")}
                    src={window?.__RUNTIME_CONFIG__?.CMS_MINI_LOGO} // eslint-disable-line
                    imgProps={{
                        loading: "lazy",
                        onError: () => setShowLogo(false),
                    }}
                />
            ) : (
                <Typography
                    color={theme.palette.primary.main}
                    sx={{ fontSize: 30 }}
                    variant="caption"
                >
                    {window?.__RUNTIME_CONFIG__?.CMS_LOGO_NAME} {/* eslint-disable-line */}
                </Typography>
            )}
            <Typography
                component="h1"
                mb={2}
                mt={2}
                textAlign="center"
                variant="h4"
            >
                {title}
            </Typography>
            {description && (
                <Typography
                    mb={2}
                    textAlign="center"
                    variant="body1"
                >
                    {description}
                </Typography>
            )}
            {!withoutButton && (
                <Button
                    id={`${buttonName}_${identifiersData.ids.button}`}
                    variant="contained"
                    onClick={onClickButton}
                >
                    {buttonText}
                </Button>
            )}
        </Box>
    );
};

export default Blank;

Blank.propTypes = {
    buttonName: PropTypes.string,
    buttonText: PropTypes.string,
    description: PropTypes.string,
    onClickButton: PropTypes.func,
    title: PropTypes.string,
    withoutButton: PropTypes.bool,
};
